module.exports = __webpack_public_path__ + "img/10m.c8c80cbc.gif";